const buttons = document.querySelectorAll(".block-swatch");
const translations = window.loveandgreen?.translations?.product || {};

// Ajoute un écouteur d'événement 'click' à chaque bouton
buttons.forEach(button => {
    button.addEventListener("click", (event) => {
        var text = ''
        var productSubscriptionWidgetContent = document.querySelector('.product-subscription-widget-subscription-content')
        if (!productSubscriptionWidgetContent || productSubscriptionWidgetContent.classList.contains('hidden')) {
            text = button.getAttribute('priceQuantity')
        } else {
            text = button.getAttribute('rechargePriceQuantity')
        }

        var textSplit = text.split("//");
        var quantity = document.querySelector('quantity-selector .quantity-selector__input').value;
        
        var quantityVariant = textSplit[0].trim()
        var price = textSplit[1].trim()

        if (quantity >= 1){
            var numericQuantity = parseFloat(quantityVariant);
            var unit = quantityVariant.replace(numericQuantity, '').trim();

            var totalQuantity = numericQuantity * quantity;

            quantityVariant = totalQuantity + ' ' + unit;
        }

        // Modifier le deuxième span de .product-subscription-widget-select-selected
        const selectedWidget = document.querySelectorAll('.product-subscription-widget-select-selected');
        selectedWidget.forEach(item => {
            const selectedSpans = item.querySelectorAll('span');

            if (selectedSpans.length >= 2) {
                const days = parseInt(selectedSpans[0].innerText.match(/\d+/)[0]) * 7;
                const quantityByDay = Math.floor(totalQuantity / days);

                selectedSpans[1].textContent = `${quantityByDay} ${unit} / ${translations.day}`;
            }
            if (selectedSpans.length >= 3) {
                selectedSpans[2].textContent = price;
            }
        })

        // Modifier les spans dans chaque div de .product-subscription-widget-select-items
        const itemsWidgets = document.querySelectorAll('.product-subscription-widget-select-items div');
        itemsWidgets.forEach(item => {
            const itemSpans = item.querySelectorAll('span');
            
            if (itemSpans.length >= 2) {
                const days = parseInt(itemSpans[0].innerText.match(/\d+/)[0]) * 7;
                const quantityByDay = Math.floor(totalQuantity / days);
                console.log("totalQuantity:", totalQuantity);

                itemSpans[1].textContent = `${quantityByDay} ${unit} / ${translations.day}`;
            }

            if (itemSpans.length >= 3) {
                itemSpans[2].textContent = price;
            }
        });

        document.querySelector('.js-number-quantity').textContent = quantityVariant;
        document.querySelector('.js-price-quantity').textContent = price;
    });
});

function updateQuantity() {
    setTimeout(() => {
        const checkedRadio = document.querySelector('.block-swatch__radio:checked');
        const parentDiv = checkedRadio.closest('[pricequantity]');

        var quantity = document.querySelector('quantity-selector .quantity-selector__input').value;

        var priceQuantity = ''
        var productSubscriptionWidgetContent = document.querySelector('.product-subscription-widget-subscription-content')
        if (!productSubscriptionWidgetContent || productSubscriptionWidgetContent.classList.contains('hidden')) {
            priceQuantity = parentDiv.getAttribute('priceQuantity');
        } else {
            priceQuantity = parentDiv.getAttribute('rechargePriceQuantity');
        }

        var textSplit = priceQuantity.split("//");

        var quantityVariant = textSplit[0].trim()
        var price = textSplit[1].trim()

        var numericQuantity = parseFloat(quantityVariant);
        var unit = quantityVariant.replace(numericQuantity, '').trim().toLowerCase();
        var totalQuantity = numericQuantity * quantity;
        quantityVariant = totalQuantity + ' ' + unit;

        document.querySelector('.js-number-quantity').textContent = quantityVariant;
        document.querySelector('.js-price-quantity').textContent = price;

        // Modifier le deuxième span de .product-subscription-widget-select-selected
        const selectedWidget = document.querySelectorAll('.product-subscription-widget-select-selected');
        selectedWidget.forEach(item => {
            console.log(selectedWidget)
            const selectedSpans = item.querySelectorAll('span');

            if (selectedSpans.length >= 2) {
                const days = parseInt(selectedSpans[0].innerText.match(/\d+/)[0]) * 7;
                const quantityByDay = Math.floor(totalQuantity / days);

                selectedSpans[1].textContent = `${quantityByDay} ${unit} / ${translations.day}`;
            }
            if (selectedSpans.length >= 3) {
                selectedSpans[2].textContent = price;
            }
        })


        // Modifier les spans dans chaque div de .product-subscription-widget-select-items
        const itemsWidgets = document.querySelectorAll('.product-subscription-widget-select-items div');
        itemsWidgets.forEach(item => {
            const itemSpans = item.querySelectorAll('span');
            
            if (itemSpans.length >= 2) {
                const days = parseInt(itemSpans[0].innerText.match(/\d+/)[0]) * 7;
                const quantityByDay = Math.floor(totalQuantity / days);

                itemSpans[1].textContent = `${quantityByDay} ${unit} / ${translations.day}`;
            }

            if (itemSpans.length >= 3) {
                itemSpans[2].textContent = price;
            }
        });

    }, 200);
}

document.querySelectorAll('quantity-selector .quantity-selector__button').forEach(button => {
    button.addEventListener('click', updateQuantity);
});

document.querySelectorAll('.product-subscription-widget-radio').forEach(button => {
    button.addEventListener('click', updateQuantity);
});